module.exports = __webpack_public_path__ + "static/media/Niveau_elN13_4_1033463.af02f8c5.png";